import React from 'react'

const Div = (props) =>
  <div {...props} />

export default Div;
